import { useQuery } from '@tanstack/react-query';
import { SitterProfileResponse } from 'happypaws-shared/src/Sitter/models/SitterProfileResponse';
import { api } from '../../services/api';

export const useGetSitters = () => {
  return useQuery({
    queryKey: ['sitters'],
    queryFn: async () => {
      const response = await api.get<SitterProfileResponse[]>('/sitters');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};
